import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productListDemoData } from '../../../../data/DashboardDemoData';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { GetNumberBeforeZero } from '../../../utils/NumberFormatter';
import cn from '../../../utils/cn';
import { ApiDashboardProductsSubscription } from '../DashboardOperation';

function InfoCard({ path, title, value = 0, icon, className }) {
    return (
        <Link
            to={path}
            className={cn(
                'bg-white shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] inline-flex items-center justify-between rounded-[15px] lg:rounded-20 w-full xl:w-76 h-20 lg:h-[100px] p-2.5 overflow-hidden',
                className
            )}
        >
            <div className="flex items-center justify-between h-full w-full">
                <div className="pl-1 lg:pl-[11px]">
                    <h2 className="text-base lg:text-xl font-medium text-primary mb-0 lg:mb-2 line-clamp-1">
                        <span>{title}</span>
                    </h2>
                    <p className="flex justify-end items-end gap-1">
                        <span className="text-[35px] lg:text-5xl leading-none font-medium text-secondary ">
                            {GetNumberBeforeZero(value)}
                        </span>
                        <span className="font-medium text-xs md:text-base text-primary-700 inline-block">
                            Subscription
                        </span>
                    </p>
                </div>

                <div className="size-[70px] lg:size-20 rounded-10 p-3 lg:p-[15px] bg-secondary-50">
                    <span className="size-full block">
                        <img src={icon} alt={title} className="size-full object-cover" />
                    </span>
                </div>
            </div>
        </Link>
    );
}

function ProductsList() {
    const { setMessage } = useTemplate();
    const [productList, setProductList] = useState(productListDemoData);

    useEffect(() => {
        ApiDashboardProductsSubscription()
            .then(({ data }) => {
                setProductList(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage]);
    return (
        <div className="flex sm:grid xl:flex sm:grid-cols-2 flex-wrap items-start justify-start gap-2 md:gap-3.5 lg:gap-4 xl:gap-5 mt-3 md:mt-5 pb-14 w-full pr-2.5">
            {productList?.map((item) => (
                <InfoCard
                    key={item.applicationId}
                    title={item.applicationName}
                    path={`/subscriptions/manage/?applications=${item?.applicationId}`}
                    icon={item.applicationLogoUrl}
                    value={item.count}
                    className={item?.demo ? 'placeholder-mode' : ''}
                />
            ))}
        </div>
    );
}

export default ProductsList;
